import PubSub from '@/service/pubsub'
import vhCheck from 'vh-check'

function windowResize() {

	var height = window.innerHeight
	var width = window.innerWidth

	window.sizeData = {
		menuIndentContent: 0,
		menuIndentHeader: 0,
		width: width,
		height: height,
		is: {
			mobile: width < 880,
			tablet: width >= 880 && width < 1200,
			desktop: width >= 1200
		}
	}

	PubSub.$emit('window.resize', window.sizeData)

}

PubSub.$on('window.initiated', function() {

	vhCheck()
	windowResize()

})

window.addEventListener('resize', windowResize)

export default {

	data: function() {
		
		return {
			window: {
				menuIndentContent: 0,
				menuIndentHeader: 0,
				width: 0,
				height: 0,
				is: {
					mobile: false,
					tablet: false,
					desktop: false
				}
			}
		}

	},

	created: function() {

		this.window = window.sizeData

		PubSub.$on('window.resize', this.onWindowResize.bind(this))

	},

	beforeDestroy: function() {

		PubSub.$off('window.resize', this.onWindowResize.bind(this))

	},

	methods: {

		onWindowResize: function(data) {

			this.window = data

		}

	}

}